import React from "react";
import Subscribe from "../../components/Subscribe/Subscribe";
import Phone from "../../assets/images/phone.svg";
import Mail from "../../assets/images/mail.svg";
import Whatsapp from "../../assets/images/whatsapp.svg";
import "./Contact.scss";

function Contact() {
  return (
    <div className="contact">
      <header className="contact__header">
        <h1 className="contact__title">Contact</h1>
        <p className="contact__lede">
          At Branded Jewellery UK we&apos;re always on hand to help with any
          enquiries. Reach us by phone, WhatsApp, or email — we&apos;ll get back
          to you as soon as we can.
        </p>
      </header>

      <ul className="contact__grid">
        <li className="contact__cell">
          <a
            href="tel:+447566209143"
            className="contact-card"
            aria-label="Call us on +44 7566 209143"
          >
            <div className="contact-card__icon-wrap">
              <img src={Phone} alt="" className="contact-card__icon" />
            </div>
            <h2 className="contact-card__label">Phone</h2>
            <p className="contact-card__value">+44 7566 209143</p>
          </a>
        </li>
        <li className="contact__cell">
          <a
            href="https://wa.me/447566209143"
            className="contact-card"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Message us on WhatsApp"
          >
            <div className="contact-card__icon-wrap">
              <img src={Whatsapp} alt="" className="contact-card__icon" />
            </div>
            <h2 className="contact-card__label">WhatsApp</h2>
            <p className="contact-card__value">+44 7566 209143</p>
          </a>
        </li>
        <li className="contact__cell">
          <a
            href="mailto:info@brandedjewelleryuk.com"
            className="contact-card"
            aria-label="Email info at brandedjewelleryuk.com"
          >
            <div className="contact-card__icon-wrap">
              <img src={Mail} alt="" className="contact-card__icon" />
            </div>
            <h2 className="contact-card__label">Email</h2>
            <p className="contact-card__value">info@brandedjewelleryuk.com</p>
          </a>
        </li>
      </ul>

      <Subscribe />
    </div>
  );
}

export default Contact;
